import { fetch } from '@maxtropy/components';
import qs from 'qs';

export interface Tenant {
  mcid: string;
  name: string;
}

interface GetRootRequest {
  value?: string;
  check?: boolean;
}
export const getRoot = (params: GetRootRequest) =>
  fetch<Tenant[]>(`/api/customer/getRoot?${qs.stringify(params, { indices: false })}`);

export interface Organization {
  mcid: string;
  name: string;
  hasPermission: boolean;
}

export interface OrganizationResponse {
  data: Organization;
  children: OrganizationResponse[];
}

export const getOrganization = (mcid: string) => fetch<OrganizationResponse>(`/api/customer/organization?mcid=${mcid}`);


export function cpSyncProgress() {
  return fetch<{ name: string; progress: number; time: string }>(
    // `http://10.50.16.213:40001/mock/502/api/v2/customer/user/cpSyncProgress`,
    `/api/v2/customer/user/cpSyncProgress`,
    {
      method: 'POST',
    },
    true
  );
}
export function cpSync() {
  return fetch(
    `/api/v2/customer/user/cpSync`,
    {
      method: 'POST',
    },
    true
  );
}
